import Withdraw from './Withdraw.jsx';
export default Withdraw;



// WEBPACK FOOTER //
// ./src/components/withdraw/index.js